import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import Modal from "@/components/Modal";

export default function ConfirmDialog({ state, busy, onClose }) {
  const open = !!state;
  const choices = state?.choices || null;
  const disabledChoices = state?.disabledChoices || [];
  const [sel, setSel] = useState(null);

  useEffect(() => {
    if (choices && choices.length) {
      const first = choices.find((c) => !disabledChoices.includes(c)) || choices[0];
      setSel(first);
    }
  }, [state]); // reset selection whenever a new dialog opens

  return (
    <Modal open={open} onClose={busy ? () => {} : onClose} title={state?.title || "Confirm"}>
      {state && (
        <div data-testid="confirm-dialog">
          <div className="flex gap-3">
            <AlertTriangle size={20} className="text-amber-400 shrink-0 mt-0.5" />
            <p className="text-sm text-zinc-300 whitespace-pre-line leading-relaxed">{state.message}</p>
          </div>
          {state.node && <div className="mt-3">{state.node}</div>}
          {choices && (
            <div className="mt-4 flex flex-wrap gap-2" data-testid="confirm-choices">
              {choices.map((c) => {
                const isDisabled = disabledChoices.includes(c);
                return (
                  <button type="button" key={c} data-testid={`confirm-choice-${c}`} disabled={busy || isDisabled} onClick={() => !isDisabled && setSel(c)}
                    className={`text-[11px] uppercase tracking-widest px-3 py-2 border rounded-sm transition-colors ${
                      isDisabled
                        ? "border-zinc-800 text-zinc-700 cursor-not-allowed opacity-40"
                        : sel === c
                          ? "border-amber-500 bg-amber-900/30 text-amber-200"
                          : "border-zinc-700 text-zinc-400 hover:border-zinc-500 hover:text-zinc-200"}`}>
                    {c}
                  </button>
                );
              })}
            </div>
          )}
          <div className="flex justify-end gap-2 mt-6">
            <button type="button" data-testid="confirm-cancel" disabled={busy} onClick={onClose}
              className="text-[11px] uppercase tracking-widest px-4 py-2 border border-zinc-700 text-zinc-400 hover:border-zinc-500 hover:text-zinc-200 transition-colors disabled:opacity-50">
              Cancel
            </button>
            <button type="button" data-testid="confirm-accept" disabled={busy || (choices && !sel)} onClick={() => state.onConfirm(sel)}
              className={`text-[11px] uppercase tracking-widest px-4 py-2 border transition-colors disabled:opacity-50 ${
                state.danger
                  ? "border-red-600 text-red-300 hover:bg-red-900/30"
                  : "border-amber-600 text-amber-300 hover:bg-amber-900/30"}`}>
              {busy ? "Working…" : (state.confirmLabel || "Confirm")}
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
}
